import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import './Dashboard.css';

function Dashboard({ setIsAuthenticated }) {
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    try {
      const response = await api.get('/api/invoices');
      setInvoices(response.data.invoices || []);
    } catch (err) {
      setError('Rechnungen konnten nicht geladen werden.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Rechnung wirklich löschen?')) return;
    try {
      await api.delete(`/api/invoices/${id}`);
      setInvoices(invoices.filter(inv => inv.id !== id));
    } catch (err) {
      alert(err.response?.data?.error || 'Fehler beim Löschen der Rechnung.');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    navigate('/login');
  };

  return (
    <div>
      <header className="header">
        <div className="header-content">
          <h1>The Castle Pub – Rechnungen</h1>
          <div className="header-actions">
            <button className="btn btn-primary" onClick={() => navigate('/create')}>
              + Neue Rechnung
            </button>
            <button className="btn btn-secondary" onClick={() => navigate('/upload')}>
              Kassenbeleg hochladen
            </button>
            <button className="btn btn-secondary" onClick={() => navigate('/customers')}>
              Kunden
            </button>
            <button className="btn btn-secondary" onClick={handleLogout}>
              Abmelden
            </button>
          </div>
        </div>
      </header>

      <div className="container">
        {/* Quick action cards */}
        <div className="action-cards">
          <div className="action-card" onClick={() => navigate('/create')}>
            <div className="action-icon">📄</div>
            <h3>Manuelle Rechnung</h3>
            <p>Rechnung ohne Kassenbeleg erstellen – Kunde, Leistung und Betrag manuell eingeben.</p>
            <button className="btn btn-primary">Rechnung erstellen</button>
          </div>
          <div className="action-card" onClick={() => navigate('/upload')}>
            <div className="action-icon">📤</div>
            <h3>Aus Kassenbeleg</h3>
            <p>PDF- oder TXT-Kassenbeleg hochladen und daraus automatisch eine Rechnung erstellen.</p>
            <button className="btn btn-secondary">Beleg hochladen</button>
          </div>
          <div className="action-card" onClick={() => navigate('/customers')}>
            <div className="action-icon">👤</div>
            <h3>Kunden</h3>
            <p>Empfänger speichern und beim nächsten Mal Name, Adresse und USt-IdNr automatisch einsetzen.</p>
            <button className="btn btn-secondary">Kunden verwalten</button>
          </div>
        </div>

        {/* Invoice list */}
        <div className="dashboard-header">
          <h2>Erstellte Rechnungen</h2>
        </div>

        {loading && <p>Lade Rechnungen...</p>}
        {error && <div className="error">{error}</div>}

        {!loading && invoices.length === 0 && (
          <div className="card" style={{ textAlign: 'center', color: '#888', padding: '40px' }}>
            <p>Noch keine Rechnungen erstellt.</p>
          </div>
        )}

        <div className="invoices-list">
          {invoices.map((invoice) => {
            const data = typeof invoice.invoice_data === 'string'
              ? JSON.parse(invoice.invoice_data)
              : invoice.invoice_data || {};

            return (
              <div key={invoice.id} className="card invoice-card">
                <div className="invoice-header">
                  <h3>Rechnung R-{String(invoice.invoice_number).padStart(6, '0')}</h3>
                  <span className="invoice-date">
                    {new Date(invoice.created_at).toLocaleDateString('de-DE')}
                  </span>
                </div>
                <div className="invoice-details">
                  {data.customer_name && <p><strong>Kunde:</strong> {data.customer_name}</p>}
                  {data.gross_amount != null && (
                    <p><strong>Betrag:</strong> € {parseFloat(data.gross_amount).toFixed(2)}</p>
                  )}
                </div>
                <div className="invoice-actions">
                  <button
                    className="btn btn-success"
                    onClick={() => navigate(`/invoice/${invoice.id}`)}
                  >
                    Anzeigen / Download
                  </button>
                  <button
                    className="btn btn-secondary"
                    style={{ backgroundColor: '#dc3545' }}
                    onClick={() => handleDelete(invoice.id)}
                  >
                    Löschen
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
